import commonExtend from '../common/extend';
export default [...commonExtend

// The markdownToolbarItems filtering below is an imperative extend() call
// (see ./index.ts) rather than a declarative Extend.* class, since it
// needs to read the admin settings at call time.
];